export class StudentOverrideConstants{
    static unsaved_messages = 'You have made changes to the pathway requirement. Do you want to cancel and discard these changes?';
    static errors = {
      override : {
        emptyOverride: 'No course has been selected to be overridden for the pathway requirement. Please select a course in order to proceed.',
        emptyTranscript: 'No transcript course has been selected to fulfill the pathway requirement. Please select a course in order to proceed.'
      },
    }
}
